import { zSchema, schemes } from "@zeal/common";

export const migrateContractorPaymentRequestSchema = zSchema.object({
  companyID: schemes.companyID(),
  csv: zSchema.string(),
  test: zSchema.boolean(),
  dryRun: zSchema.boolean().optional(),
});

export type TMigrateContractorPaymentRequest = zSchema.infer<
  typeof migrateContractorPaymentRequestSchema
>;

export const migrateContractorPaymentResponseSchema = zSchema.object({
  dryRun: zSchema.boolean().optional(),
  ytdDetails: zSchema.array(
    zSchema.object({
      contractorID: zSchema.string(),
      payDate: zSchema.string(),
      payAmount: zSchema.number(),
      contractorName: zSchema.string().optional(),
      companyID: zSchema.string().optional(),
    })
  ),
  contractorDetails: zSchema.array(
    zSchema.object({
      contractorID: zSchema.string(),
      name: zSchema.string(),
      companyID: zSchema.string(),
    })
  ),
  unexpectedColumns: zSchema.array(zSchema.string()),
  paymentsCreated: zSchema.array(zSchema.string()),
  failedRows: zSchema
    .array(
      zSchema.object({
        contractorID: zSchema.string(),
        payDate: zSchema.string(),
        payAmount: zSchema.number(),
        reason: zSchema.string(),
      })
    )
    .optional(),
});

export type TMigrateContractorPaymentResponse = zSchema.infer<
  typeof migrateContractorPaymentResponseSchema
>;
